<template>
  <div class="society-table-container my-3">
    <h5 class="mb-2">{{ questionName }}</h5>
    <b-table-lite
      :items="societies"
      :fields="societyFields"
      small
      striped
      hover
      responsive
      outlined
      class="m-0"
    >
    </b-table-lite>
  </div>
</template>

<script>
import { formatDate, formatRut } from "@/plugins/complianceScripts";

export default {
  name: "SocietyTable",
  props: {
    societies: {
      type: Array,
      required: true,
      default: () => [],
    },
    questionName: {
      type: String,
      required: true,
    },
    fieldNameCargo: {
      type: String,
      default: "Cargo",
    },
    fieldNameDate: {
      type: String,
      default: "Periodo",
    },
  },
  computed: {
    societyFields() {
      return [
        { key: "name", label: "Nombre", thClass: "col-4" },
        { key: "rut", label: "RUT", thClass: "col-2", formatter: formatRut },
        { key: "position", label: this.fieldNameCargo, thClass: "col-3" },
        {
          key: "period",
          label: this.fieldNameDate,
          thClass: "col-3",
          formatter: formatDate,
        },
      ];
    },
  },
};
</script>
